import { render, staticRenderFns } from "./BookListPage.vue?vue&type=template&id=3b21f43f"
import script from "./BookListPage.vue?vue&type=script&lang=js"
export * from "./BookListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports